import { Box, Text, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface IContactInfoCell {
  contactName: string;
  designation?: string;
  email?: string;
  phoneNumber?: string;
}

export const ContactInfoCell: React.FC<IContactInfoCell> = ({ contactName, designation, email, phoneNumber }) => (
  <Box py={2} px={1} minW='200px'>
    <VStack align='start' spacing={2}>
      <Text fontWeight='semibold' fontSize='md' color='gray.800' lineHeight='1.3' wordBreak='break-word'>
        {contactName}
      </Text>

      {designation && (
        <Text fontSize='sm' color='gray.600' lineHeight='1.3' fontStyle='italic' wordBreak='break-word'>
          {designation}
        </Text>
      )}

      {email && (
        <Text
          fontSize='sm'
          color='blue.600'
          lineHeight='1.3'
          _hover={{ color: 'blue.700', cursor: 'pointer' }}
          wordBreak='break-all'>
          {email}
        </Text>
      )}

      {phoneNumber && (
        <Text
          fontSize='sm'
          color='gray.600'
          lineHeight='1.3'
          fontFamily='mono'
          letterSpacing='0.5px'
          wordBreak='break-word'>
          {phoneNumber}
        </Text>
      )}
    </VStack>
  </Box>
);
